var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.brandList),function(item,index){return _c('img',{key:index,staticClass:"brand-img",attrs:{"src":item.url,"alt":""},on:{"click":function($event){return _vm.toBrandDetail(item.type)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }